import Script from 'next/script';
import Style from './BancoDoAutoModalDisclaimer.css';
import Container from '../../atoms/Container';
import React, { useState, useEffect } from 'react';

function BancoDoAutoModalDisclaimer({ notModal }) {
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (showModal) {
      document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
    } else {
      document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
    }
  }, [showModal]);
  return (
    <>
      <section id="modal-disclaimer">
        {showModal && (
          <div id="modal">
            <button
              id="closeBtn"
              onClick={(e) => {
                e.preventDefault();
                setShowModal(false);
              }}
            >
              <img src="assets/shared/close-modal.png" loading="lazy" alt="" />
            </button>
            <p>
              Sujeito a análise e aprovação de crédito. A título de exemplo, para a taxa de juros de
              1,19% a.m., considerando uma simulação realizada em 22/10/2025, com base em um
              financiamento de veículo no valor de R$ 125.000,00, com entrada de R$ 75.000,00 e
              financiamento de R$ 50.000,00, em 24 parcelas fixas de R$ 2.476,04, sem inclusão de
              tarifas, registro no DETRAN e IOF, o Custo Efetivo Total (CET) é de 18,58% a.a.
            </p>
          </div>
        )}
        <Container>
          {notModal && <p id="notOpenModal">Sujeito a análise de crédito. Consulte condições.</p>}
          {!notModal && (
            <a
              id="openModal"
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
            >
              Sujeito a análise de crédito. <b>Consulte condições.</b>
            </a>
          )}
          <p id="text-disclaimer">
            F1, FORMULA ONE, FORMULA 1, FIA FORMULA ONE WORLD CHAMPIONSHIP,GRAND PRIX and related
            marks are trademarks of Formula One Licensing B.V. FORMULA 1 Images © Formula One World
            Championship Limited 2025. All rights reserved.
          </p>
        </Container>
      </section>
      {showModal && (
        <div
          id="backgroudModal"
          onClick={(e) => {
            e.preventDefault();
            setShowModal(false);
          }}
        />
      )}
      <style jsx>{Style}</style>
    </>
  );
}

export default BancoDoAutoModalDisclaimer;
